import { createAction, props } from '@ngrx/store';
import { LobbyEntryDetail } from 'src/app/lobby/shared/models/lobby-entry-detail';
import { WrapUp } from '../../shared/models/wrap-up';
import { LobbyEntryImpersonateAssist } from 'src/app/lobby/shared/models/lobby-entry-impersonate.dto';

export const assistLobbyEntry = createAction(
    '[Wrap Up Page] Assist Lobby Entry',
    props<{ lobbyEntryId: number, assistingUserId: number, isInstantAssist: boolean, locationId: number, showLobbyCategory: boolean, isImpersonateAssist: boolean|false, impersonateByName: string|null }>()
);

export const setImpersonateDetails = createAction(
    '[Wrap Up Page] Set Impersonate Detail',
    props<{ isImpersonate: boolean, impersonateByName:string, impersonatedByCode: string }>()
);

export const impersonateAssistLobbyEntry = createAction(
    '[Wrap Up Page] Impersonate Assist Lobby Entry',
    props<{ payload:LobbyEntryImpersonateAssist }>()
);

export const provideService = createAction(
    '[Wrap Up Page] Provide Service',
    props<{ lobbyEntryId: number, serviceId: number }>()
);

export const updateProvidedServiceReference = createAction(
    '[Wrap Up Page] Update Provided Service Reference',
    props<{ lobbyEntryId: number, serviceProvidedId: number, reference: string }>()
);

export const removeProvidedService = createAction(
    '[Wrap Up Page] Remove Provided Service',
    props<{ lobbyEntryId: number, serviceProvidedId: number }>()
);

export const hideWrapUp = createAction(
    '[Wrap Up Page] Hide Wrap Up'
);

export const closeWrapUp = createAction(
    '[Wrap Up Page] Close Wrap Up'
);

export const showWrapUp = createAction(
    '[Wrap Up Page] Show Wrap Up',
    props<{ isImpersonateAssist:boolean }>()
);

export const backToLobby = createAction(
    '[Wrap Up Page] Back To Lobby',
    props<{ lobbyEntryId: number,assistingUserLocationId:number,isImpersonateAssist:boolean,comment:string }>()
);

export const getCheckList = createAction(
    '[Wrap Up Page] Get Check List',
    props<{ serviceId: number }>()
);

export const loadWrapUpPopUp= createAction(
    '[Wrap Up Page] Open Wrap up',
  props<{ lobbyEntryId: number, impersonatedByName: string, isImpersonateAssist: boolean, showLobbyCateogory: boolean, impersonatedByCode: string }>()
);

export const getCheckListForRequestedService = createAction(
    '[Wrap Up Page] Get Check List For Requested Service',
    props<{ serviceIds: number[] }>()
);

export const closeCheckList = createAction(
    '[Wrap Up Page] Close Check List'
);

export const closeRequestedServiceCheckList = createAction(
    '[Wrap Up Page] Close Requested Service Check List'
);

export const setWrapUpComment = createAction(
    '[Wrap Up Page] Set Wrap Up Comment',
    props<{ comment: string }>()
);

export const wrapUpAssist = createAction(
    '[Wrap Up Page] Wrap Up Assist',
    props<{ wrapUpData: WrapUp }>()
);

export const setSearchFilter = createAction(
    '[Wrap Up Page] Set Search Filter',
    props<{ searchValue: string }>()
);

export const lobbyEntryIdCoppiedToClipBoard = createAction(
    '[Wrap Up Page] Lobby Entry Id Coppied To ClipBoard'
);

export const showEditServiceReference = createAction(
    '[Wrap Up Page] Show Edit Service Reference',
    props<{lobbyEntryDetail: LobbyEntryDetail }>()
);

export const isVisitorArrived = createAction(
    '[Wrap Up Page] Set Visitor Arrived Status',
    props<{ lobbyEntryId: number, isArrived: boolean }>()
);
